<template>
  <div style="margin-top:20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Manage Views & Reports Settings</span><br/>
    </div>
    
    <div v-if="!loading" style="text-align: left; color: #666;" class="d-flex align-items-center justify-content-center">
      <form @submit.prevent="save_config">
        <table width="90%" style="font-size: 18px; font-weight: bold" cellpadding="10px">
          <tr>
            <td align="right" width="500">Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Payroll Notes Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_payroll_notes_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Overnight Hours Offset</td>
            <td width="500"><b-form-input v-model="model.views_reports_overnight_hour_offset" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Report Start Min Planned</td>
            <td width="500"><b-form-select v-model="model.views_reports_vehicle_report_start_min_planned" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Start Stop Private Only</td>
            <td width="500"><b-form-select v-model="model.views_reports_vehicle_report_start_stop_private_only" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Start Stop Contract Only</td>
            <td width="500"><b-form-select v-model="model.views_reports_vehicle_report_start_stop_contract_only" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Start Stop Columns</td>
            <td width="500"><b-form-input v-model="model.views_reports_vehicle_report_start_stop_columns" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Vehicle Type Filter</td>
            <td width="500"><b-form-input v-model="model.views_reports_vehicle_type_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Payroll Company</td>
            <td width="500"><b-form-input v-model="model.views_reports_payroll_company" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_payroll_company === 'paycom'">
            <td align="right" width="500">Paycom Terminal Group Timezone (hours)</td>
            <td width="800"><b-form-textarea v-model="model.views_reports_paycom_terminal_group_compensation" rows="4" placeholder='{"DRI": 2, "HOU": 2, "MST": 1, "IDA": 1}' style="field-sizing: content; font-family: monospace"/></td>
            <td width="250" style="font-size: 12px; color: #888;">JSON: terminal group code → hours to add to CST for local time. Leave blank for no offset.</td>
          </tr>
          <tr v-if="user.tenant == 'starline-tbn-bdc7f899'">
            <td align="right" width="500">Payroll Categories</td>
            <td width="500"><b-form-input v-model="model.views_reports_payroll_categories" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.tenant == 'starline-tbn-bdc7f899'">
            <td align="right" width="500">Payroll Report Config</td>
            <td width="800"><b-form-textarea v-model="model.views_reports_payroll_category_report_config" style="field-sizing: content"/></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Start Threshold Minutes</td>
            <td width="500"><b-form-input v-model="model.views_reports_vehicle_report_start_threshold_minutes" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Start Offset Minutes</td>
            <td width="500"><b-form-input v-model="model.views_reports_vehicle_report_start_offset_minutes" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Finish Offset Minutes</td>
            <td width="500"><b-form-input v-model="model.views_reports_vehicle_report_finish_offset_minutes" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Round To Nearest Minutes</td>
            <td width="500"><b-form-input v-model="model.views_reports_vehicle_report_round_to_minutes" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Payroll Push Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_driver_payroll_push_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Payroll Push Bookings Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_driver_payroll_push_bookings_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Payroll Use Planned Start As Actual</td>
            <td width="500"><b-form-select v-model="model.views_reports_driver_payroll_use_planned_start_as_actual" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Payroll Max Off Duty Gap</td>
            <td width="500"><b-form-input v-model="model.views_reports_driver_payroll_max_off_duty_gap" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Payroll Minimum Hours</td>
            <td width="500"><b-form-input v-model="model.views_reports_driver_payroll_minimum_hours" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Payroll Middle Day Min Hours</td>
            <td width="500"><b-form-input v-model="model.views_reports_driver_payroll_middle_day_min_hours" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.tenant == 'mtrwestern-tbn-3db5da5g7'">
            <td align="right" width="500">Payroll LOS Mappings</td>
            <td width="500"><b-form-input v-model="model.views_reports_driver_payroll_los_mappings" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.tenant == 'mtrwestern-tbn-3db5da5g7'">
            <td align="right" width="500">Paroll Ski Client IDs</td>
            <td width="500"><b-form-input v-model="model.views_reports_driver_payroll_ski_client_ids" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.tenant == 'mtrwestern-tbn-3db5da5g7'">
            <td align="right" width="500">Payroll Push Filter</td>
            <td width="500"><b-form-input v-model="model.views_reports_driver_payroll_push_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">HOS Nightly Report Config</td>
            <td width="500"><b-form-input v-model="model.views_reports_hos_nightly_report_config" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Nightly Alerts Report Config</td>
            <td width="500"><b-form-input v-model="model.views_reports_nightly_alerts_report_config" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Nightly Report Config</td>
            <td width="500"><b-form-input v-model="model.views_reports_nightly_report_config" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">OTP Report Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_report_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Report Use Same Spot & Pickup</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_report_use_same_spot_and_pickup" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Stop Notes Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_stop_notes_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Stop Arrivals Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_arrivals_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Adjust Stop Timezones</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_report_adjust_stop_timezones" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Report Portico Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_report_portico_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Skip First & Last Stop</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_report_skip_first_and_last_stop_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Email Recipients</td>
            <td width="500"><b-form-input v-model="model.views_reports_otp_report_email_recipients" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Include Drivers</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_report_include_drivers_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Use Driver Assignments To Vehicles</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_report_use_driver_assignments_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Report Arrival Early Minutes Limit</td>
            <td width="500"><b-form-input v-model="model.views_reports_otp_report_arrival_early_minutes_limit" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Report Arrival Late Minutes Limit</td>
            <td width="500"><b-form-input v-model="model.views_reports_otp_report_arrival_late_minutes_limit" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Report Departure Early Minutes Limit</td>
            <td width="500"><b-form-input v-model="model.views_reports_otp_report_departure_early_minutes_limit" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Report Departure Late Minutes Limit</td>
            <td width="500"><b-form-input v-model="model.views_reports_otp_report_departure_late_minutes_limit" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Report Send Filter At Time</td>
            <td width="500"><b-form-input v-model="model.views_reports_otp_report_send_filter_at_time" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Report Multiday Config</td>
            <td width="500"><b-form-textarea v-model="model.views_reports_otp_report_multiday_config" style="field-sizing: content"/></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Routes Charter Filter</td>
            <td width="500"><b-form-input v-model="model.routes_charter_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Routes Company Filter</td>
            <td width="500"><b-form-input v-model="model.routes_company_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Routes Filter</td>
            <td width="500"><b-form-input v-model="model.routes_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Routes Type Filter</td>
            <td width="500"><b-form-input v-model="model.routes_type_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Routes Name Field</td>
            <td width="500"><b-form-input v-model="model.routes_name_field" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.tenant == 'polyad-9a91d945'">
            <td align="right" width="500">Process Trip Sheets Doc Type</td>
            <td width="500"><b-form-input v-model="model.views_reports_process_trip_sheets_doc_type" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.tenant == 'polyad-9a91d945'">
            <td align="right" width="500">Process Trip Sheets Email Recipients</td>
            <td width="500"><b-form-input v-model="model.views_reports_process_trip_sheets_email_recipients" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type == 'TBN'">
            <td align="right" width="500">Dispatch Board Visible Fields</td>
            <td width="500"><b-form-input v-model="model.views_reports_dispatch_board_visible_fields" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Trip Sheet Visible Fields</td>
            <td width="500"><b-form-input v-model="model.views_reports_trip_sheet_visible_fields" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Trip Sheets Enabed</td>
            <td width="500"><b-form-select v-model="model.views_reports_process_trip_sheets_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type == 'TBN'">
            <td align="right" width="500">Dispatch Board Current Departures Only</td>
            <td width="500"><b-form-select v-model="model.views_reports_dispatch_board_current_departures_only" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type == 'TBN'">
            <td align="right" width="500">Intrastate Report Skip Route Names</td>
            <td width="500"><b-form-textarea v-model="model.views_reports_intrastate_skip_routes" style="field-sizing: content"/></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="telematics_type == 'SAMSARA'">
            <td align="right" width="500">Samsara Safety Report Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_samsara_safety_report_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="telematics_type == 'SAMSARA'">
            <td align="right" width="500">Samsara Vehicle Mileage Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_samsara_vehicle_mileage_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Vehicle Monthly Type Mappings</td>
            <td width="500"><b-form-textarea v-model="model.views_reports_veh_monthly_type_mappings" style="field-sizing: content"></b-form-textarea></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.role == 'admin'">
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isAdvVisible')">+ Advanced</span></td>
            <td></td>
            <td></td>
          </tr>
          <template v-if="toggle.isAdvVisible">
            <tr>
              <td align="right" width="500">Employee ID Matching Enabled</td>
              <td width="500"><b-form-select v-model="model.employee_id_matching_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250" style="font-size: 12px; color: #888;">Match by ID (TBN Ref ID / Samsara Username / Paycom eecode) instead of name</td>
            </tr>
          </template>
        </table>

        <hr/>
        <div style="position: relative" class="d-flex align-items-center justify-content-center">
          <b-btn size="lg" type="submit" variant="success" id="save-user-submit">Save</b-btn>
          &nbsp;&nbsp;<b-btn size="lg" @click="load_data()">Cancel</b-btn>
        </div>

      </form>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
import {mapState} from "vuex";

export default {
  name: 'tenant_config',
  components: {
  },

  data() {
    return {
      group_name: 'general',
      add_yard_model: {},
      manage_sos_yards: false,
      model: {},
      general_model: {},
      general_advanced_model: {},
      toggle: {},
      summary: {},
      loading: true,
      isNotSysadmin: false,
      isSamaraType: false,
      yardsLength: 0,
      objectKeyList:[],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results
        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              //console.log('found plain object or array: key:'+key+ ' value: '+ setting);
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
        } catch(e) {
          console.log('error looping through keys',e)
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async save_config() {
      try {
        window.scrollTo(0,0);
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        //return value to object 
        //console.log("this.objectKeyList: " + JSON.stringify(this.objectKeyList))
        for (const objkey of this.objectKeyList) {
          try {
            let setting = JSON.parse(this.model[objkey])
            this.model[objkey] = setting
          } catch (e) {
            console.log('exception parsing object keys for objkey:' + objkey, e)
          }
        }
        await update_tenant_config_settings(this.user.tenant, this.model, this.group_name)
        this.load_data()
        this.$emit('showAlert', 'Configuration Saved', 'success',5000)
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item,field,setting) {
      if (!item[field] && setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      } else if (item[field] && !setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    isPlainObject(value,key) {
      //console.log('isPlainObject, value:' + value + ', type of value:' + (typeof value))
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value) {
      return Array.isArray(value)
    },
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    is_admin() {
      return this.user.role === 'admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";
</style>

